import { MoveableArea } from 'foundations-components/transitional/components/MoveableArea';
import { CommentableArea } from 'collaboration-sidebar';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SinglePaymentLinkStatus = ({
  label
}) => /*#__PURE__*/_jsxs("span", {
  "data-test-id": "payments-on-status-dot",
  children: [/*#__PURE__*/_jsx(StatusDot, {}), /*#__PURE__*/_jsx(Text, {
    as: "small",
    children: label ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: 'editor.form.properties.submit.paymentsTurnedOnWithLabel',
      options: {
        label
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'editor.form.properties.submit.paymentsTurnedOn'
    })
  })]
});
const SubmitButton = ({
  submitText,
  paymentLabel,
  selected,
  paymentActive,
  handleSubmitSelect
}) => /*#__PURE__*/_jsx("div", {
  "data-test-id": "submit-select",
  children: /*#__PURE__*/_jsx(CommentableArea, {
    moduleId: "submit-button",
    verticalPositioning: true,
    description: {
      translationKey: 'formsSubmit'
    },
    children: /*#__PURE__*/_jsxs(MoveableArea, {
      draggable: false,
      containerDraggable: true,
      selected: selected,
      onSelectedChange: ({
        target: {
          value
        }
      }) => handleSubmitSelect(value),
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "form-field-submit-button",
        use: "primary",
        children: submitText
      }), paymentActive ? /*#__PURE__*/_jsx(SinglePaymentLinkStatus, {
        label: paymentLabel
      }) : null]
    })
  })
});
export default SubmitButton;